import { render, staticRenderFns } from "./CompanyFile.vue?vue&type=template&id=a70aef24&scoped=true&"
import script from "./CompanyFile.vue?vue&type=script&lang=js&"
export * from "./CompanyFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70aef24",
  null
  
)

export default component.exports